import AuditBreakdown from './AuditBreakdown';

export default function FounderBeta() {
  return (
    <section id="beta" className="py-32 px-6 bg-[#080810] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `linear-gradient(rgba(0,255,180,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(0,255,180,0.04) 1px, transparent 1px)`,
          backgroundSize: '80px 80px'
        }}></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        {/* Founder Section */}
        <div className="mb-32">
          <div className="text-center mb-16">
            <div className="mb-8">
              <div className="w-36 h-36 mx-auto rounded-full overflow-hidden border-2 border-[#00ffb4]/30">
                <img
                  src="https://static.readdy.ai/image/378dd0f6400ec53d43ae7d1d7dd92295/cc649cd86b93c43cf6aaed224240cbf8.jpeg"
                  alt="Guanying Lin - TWINODE 創辦人暨系統架構師"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="text-xs tracking-widest text-gray-600 font-mono mb-4">THE ARCHITECT</div>
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">系統架構師：林冠穎</h2>
            <p className="text-sm text-gray-500 max-w-xl mx-auto font-mono">
              創辦人、CEO 暨系統架構師
            </p>
          </div>

          <div className="max-w-4xl mx-auto mb-16">
            <div className="border-l-2 pl-8 py-4" style={{ borderColor: '#00ffb4' }}>
              <p className="text-base leading-relaxed text-gray-400">
                我的背景並非鍛造於傳統計算機科學，而是在容錯率為零的環境中磨礪而成。從狙擊手的瞄準鏡到米其林星級廚房，再到規模化第一個創業項目，底層真相始終如一：<span className="text-white font-bold">系統在參數被忽視時崩潰。</span> TWINODE 是經濟邏輯、極致標準化與戰術精度的數字化結晶。
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-focus-3-line',
                discipline: 'DISCIPLINE 01',
                title: '戰術精度',
                sub: '台灣軍事狙擊手',
                desc: '在極端壓力下掌握多維環境變量的計算。這一紀律構成了 TWINODE 的核心演算邏輯：先計算參數，再執行決策。'
              },
              {
                icon: 'ri-restaurant-line',
                discipline: 'DISCIPLINE 02',
                title: '極致標準化',
                sub: '頂級餐飲業',
                desc: '3 年以上在台北米其林一星與雪梨雙帽精英廚藝團隊的經歷。構建無懈可擊的執行力與嚴格的 SOP，確保每個數據流達到最高效率。'
              },
              {
                icon: 'ri-line-chart-line',
                discipline: 'DISCIPLINE 03',
                title: '商業驗證',
                sub: '經濟學與規模化',
                desc: '從國立台北大學經濟系輟學，以橋接理論與現實執行。30 歲前在餐飲業規模化第一個創業項目，驗證了將複雜系統商業化與標準化運營的能力。'
              }
            ].map((item) => (
              <div key={item.title} className="border border-[#00ffb4]/15 p-8 rounded-lg flex flex-col gap-6 hover:border-[#00ffb4]/40 hover:bg-[#00ffb4]/5 transition-all duration-300 group cursor-default bg-[#0a0a0f]">
                <div className="w-12 h-12 flex items-center justify-center border border-[#00ffb4]/30 rounded-full transition-all duration-300 group-hover:bg-[#00ffb4]/10">
                  <i className={`${item.icon} text-xl`} style={{ color: '#00ffb4' }}></i>
                </div>
                <div>
                  <div className="text-xs tracking-widest text-gray-600 font-mono mb-2">{item.discipline}</div>
                  <h3 className="text-xl font-bold mb-3 text-white">{item.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed mb-3">{item.sub}</p>
                  <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Audit Breakdown */}
        <AuditBreakdown />

        {/* Footer */}
        <footer className="mt-20 pt-12 border-t border-[#00ffb4]/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex flex-col items-center md:items-start gap-2">
              <div className="flex items-center space-x-3">
                <img
                  src="https://static.readdy.ai/image/378dd0f6400ec53d43ae7d1d7dd92295/8acfdc25fd3b0de57798749a193ed73d.png"
                  alt="TWINODE Logo"
                  className="h-8 w-8 object-contain"
                />
                <span className="font-bold text-white">TWINODE</span>
              </div>
              <p className="text-xs text-gray-600 font-mono italic">
                TWINODE Labs. Push causal inference into its next evolution.
              </p>
            </div>

            <div className="flex items-center gap-6 text-xs text-gray-600">
              <a href="#philosophy" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">核心理念</a>
              <a href="#architecture" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">系統架構</a>
              <a href="#sample" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">報告樣本</a>
              <a href="#security-faq" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">常見問題</a>
              <a href="/privacy" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">隱私政策</a>
            </div>

            <div className="text-xs text-gray-600 font-mono">
              © 2026 TWINODE Labs. All rights reserved.
            </div>
          </div>
        </footer>
      </div>
    </section>
  );
}
